<template>
  <div
    class="custom-animation tw-relative tw-h-full tw-bg-white tw-rounded tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]"
  >
    <div
      id="dash-cyber-health-assessment-title"
      class="tw-h-[66px] tw-rounded-t tw-flex tw-justify-between tw-items-center tw-bg-[#FCFCFD] tw-py-[25px] tw-px-[20px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]"
    >
      <div class="tw-flex tw-gap-[10px]">
        <span class="tw-text-[#211F58] tw-text-[18px] tw-font-semibold">
          {{
            getComponentUiText("app-dashboard-cyber-health-assessment-title-1")
          }}
        </span>
        <span
          v-if="!isShowDummy && latestChecklistDetail.checklistDateCreated"
          class="tw-text-[#211F58] tw-text-[18px]"
        >
          –
          {{
            convertUTCTimeToLocalTime(
              latestChecklistDetail.checklistDateReporting
                ? latestChecklistDetail.checklistDateReporting
                : latestChecklistDetail.checklistDateCreated,
            )
          }}
        </span>
      </div>
    </div>
    <div
      v-if="isLoading || loadingChecklist"
      class="custom-global-skeleton tw-p-[20px] tw-h-[182px]"
    ></div>
    <!--
 <div
      v-else-if="
        isChecklistMetricsCompletionLoading ||
        isChecklistInfoDetailLoading ||
        isChecklistMetricsCompletionLoading
      "
      class="tw-h-[182px]"
    ></div> 
-->
    <div v-else :class="`tw-p-[20px] ${isShowDummy ? 'tw-h-[182px]' : ''}`">
      <div class="tw-flex tw-gap-[20px] tw-flex-wrap">
        <div
          class="tw-flex tw-flex-col tw-grow tw-gap-[6px] tw-justify-between"
        >
          <div class="tw-flex tw-justify-between tw-items-center">
            <div
              class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[130%] title"
            >
              {{
                getComponentUiText("app-component-assessment-title-status-1")
              }}
            </div>

            <AssessmentChecklistStatusTag
              :checklist-status="
                isShowDummy
                  ? dummyData.checklistStatus
                  : latestChecklistDetail.checklistStatus
              "
              :checklist-status-id="
                isShowDummy
                  ? dummyData.checklistStatusId
                  : latestChecklistDetail.checklistStatusId
              "
              :is-loading="false"
            />
          </div>
          <div class="tw-flex tw-justify-between tw-items-center">
            <div
              class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
            >
              {{
                getComponentUiText("app-component-assessment-title-progress-1")
              }}
            </div>
            <div
              v-if="isChecklistMetricsCompletionLoading"
              class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
            ></div>
            <div v-else class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
              {{ checklistMetricsCompletion.checklistCompletion }}/{{
                checklistMetricsCompletion.checklistCompletionMax
              }}
              <span class="tw-text-[#878787] tw-font-[500]"
                >{{ percentProgress }}%</span
              >
            </div>
          </div>
          <div class="tw-flex tw-justify-between tw-items-center">
            <div
              class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
            >
              {{
                getComponentUiText(
                  "app-component-assessments-question-type-2-icon-tooltip-score-1",
                )
              }}
            </div>
            <div
              class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
            >
              <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
                {{ Math.round(+checklistCompletion?.checklistScore) }}/{{
                  Math.round(+checklistCompletion?.checklistScoreMax)
                }}
                <span class="tw-text-[#878787] tw-font-[500]"
                  >{{
                    (checklistCompletion?.checklistScorePcnt * 100).toFixed(1)
                  }}%</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="tw-flex tw-grow tw-gap-[20px] tw-flex-wrap">
          <div
            class="tw-flex tw-flex-col tw-grow tw-gap-[6px] tw-justify-between"
          >
            <!-- Template -->
            <div class="tw-flex tw-justify-between tw-items-center">
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[135%] title"
              >
                {{
                  getComponentUiText(
                    "app-dashboard-cyber-health-assessment-title-template-1",
                  )
                }}
              </div>
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              >
                <div
                  v-if="
                    isShowDummy
                      ? true
                      : latestChecklistDetail?.templates.length > 0 &&
                        latestChecklistDetail?.templates[0]
                          ?.checklistTemplateName
                  "
                  class="default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-[#878787]"
                >
                  {{
                    latestChecklistDetail?.templates?.length > 0
                      ? getShortChecklistName(
                          latestChecklistDetail?.templates[0]
                            ?.checklistTemplateName,
                        )
                      : getComponentUiText(
                          "app-component-assessments-checklists-assessment-template-tag-1",
                        )
                  }}
                </div>
                <div
                  v-else
                  class="default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-[#878787]"
                >
                  {{
                    getComponentUiText(
                      "app-component-assessments-checklists-assessment-template-tag-1",
                    )
                  }}
                </div>
              </div>
            </div>
            <!-- Last updated -->
            <div class="tw-flex tw-justify-between tw-items-center">
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              >
                {{
                  latestChecklistDetail.checklistStatusId !==
                  checklistStatusId.completed
                    ? getComponentUiText(
                        "app-component-assessments-checklists-assessment-details-card-label-2",
                      )
                    : getComponentUiText(
                        "app-component-assessments-checklists-assessment-details-card-label-3",
                      )
                }}
              </div>
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              >
                <div class="tw-text-[#878787] tw-text-[13px] tw-font-[400]">
                  {{ getLastUpdatedTimeFromNow() }}
                </div>
              </div>
            </div>
            <!-- Created -->
            <div class="tw-flex tw-justify-between tw-items-center">
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              >
                {{
                  getComponentUiText("app-dashboard-assessment-status-title-1")
                }}
              </div>
              <div
                class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              >
                <div class="tw-text-[#878787] tw-text-[13px] tw-font-[400]">
                  {{ getCurrentTime() }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isShowRadial"
            :class="[
              'tw-flex tw-items-center tw-justify-center tw-bg-[#ffffff] tw-w-[72px] tw-h-[72px]',
            ]"
          >
            <div
              class="tw-w-[72px] tw-h-[72px] tw-flex tw-items-center tw-justify-center tw-text-[30px] tw-font-[600]"
              :class="`tw-text-[${
                TEXT_COLOR_WITH_GRADE_SCORE[
                  generateGradeScoreWithCompletedScore(Number(percentScore))
                ]
              }]`"
            >
              {{ generateGradeScoreWithCompletedScore(Number(percentScore)) }}
            </div>
          </div>
          <RadialProgressBar
            v-else
            class="d-inline"
            :total-steps="100"
            :completed-steps="isShowDummy ? 60 : percentProgress"
            :is-hide-progress="true"
            outer-stroke-color="#48A0FF"
          />
        </div>
      </div>
      <div
        v-if="
          !(
            latestChecklistDetail.checklistStatusId ===
              checklistStatusId.defunct || percentProgress === 100
          ) ||
          latestChecklistDetail.checklistStatusId ===
            checklistStatusId.completed
        "
        class="tw-mt-[20px] tw-px-[20px] tw-py-[15px] tw-bg-[#D9EDE2] tw-rounded-md tw-flex tw-justify-between tw-items-center"
      >
        <div class="tw-flex tw-items-center tw-gap-[12px]">
          <img
            src="/img/bulb_icon.svg"
            alt="bulb"
            class="tw-w-[18px] tw-h-[18px] icon"
            style=""
          />
          <div class="tw-text-[13px] tw-font-[400]">
            {{
              latestChecklistDetail.checklistStatusId ===
              checklistStatusId.completed
                ? getComponentUiText(
                    "app-dashboard-cyber-health-assessment-description-tooltip-2",
                  )
                : getComponentUiText(
                    "app-dashboard-cyber-health-assessment-description-tooltip-1",
                  )
            }}
          </div>
        </div>
        <div
          class="tw-cursor-pointer tw-px-[16px] tw-py-[5px] tw-rounded-[26.909px] tw-bg-white tw-flex tw-items-center tw-text-[#387DFF] tw-text-[11px] tw-font-medium"
          @click="goToContinueAssessment"
        >
          {{
            latestChecklistDetail.checklistStatusId ===
            checklistStatusId.completed
              ? getComponentUiText(
                  "app-component-assessment-detail-dropdown-option-view-assessment-title-1",
                )
              : getComponentUiText(
                  "app-dashboard-cyber-health-assessment-btn-description-tooltip-1",
                )
          }}
        </div>
      </div>
    </div>
    <DummyCard
      v-if="isShowDummy && !loadingChecklist"
      :title="
        getComponentUiText('app-dashboard-dummy-title-cyber-health-score-1')
      "
      :title-button="
        getComponentUiText('app-assessment-button-create-button-2')
      "
      :title-class="'tw-w-[276px]'"
      @button:click="() => emits('button:click')"
    />
  </div>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { getComponentUiText, getShortChecklistName } from "@/utils/utilities";
import {
  IChecklistInfoDetail,
  IChecklistMetrics,
  IChecklistMetricsCompletion,
} from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import {
  generateCheklistStatusIdToChecklistStatusName,
  generateGradeScoreWithCompletedScore,
  getCheckListIdMetricsCompletion,
  getDetailFromCheckListId,
  TEXT_COLOR_WITH_GRADE_SCORE,
} from "@/services/assessment";
import { assessmentStatus, CHECKLISTSTATUS } from "@/utils/constants";
import {
  convertUTCTimeToLocalTime,
  getTimeFromNow,
} from "@/utils/dateTimeUtils";
import router from "@/router";
import { checklistStatusId } from "@/utils/constants";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import DummyCard from "./dummyCard.vue";
import get from "lodash/get";

const props = defineProps({
  loadingChecklist: {
    type: Boolean,
    default: true,
    required: false,
  },
  checklistId: {
    type: String,
    required: true,
  },
  metric: {
    type: Object as () => IChecklistMetrics,
    required: true,
  },
});

const isLoading = ref(false);
const checklistCompletion: Ref<IChecklistMetrics> = ref(
  {} as IChecklistMetrics,
);

const latestChecklistDetail = computed(() => {
  const cl = store.getters["Recommend/getChecklistDetailById"](
    props.checklistId,
  );
  return cl || {};
});
const checklistLastUpdatedDate = ref("");

const percentScore = computed(() => {
  const score = checklistCompletion.value?.checklistScorePcnt;
  return (score * 100).toFixed(2);
});

const isShowRadial = computed(() => {
  return (
    latestChecklistDetail.value?.checklistStatusId !== CHECKLISTSTATUS.DONE
  );
});

const emits = defineEmits(["button:click"]);

const dummyData = ref({
  checklistStatusName: "Checklist Status",
  checklistStatus: "Created",
  checklistStatusId: "new",
  checklistCompletion: 0,
  checklistCompletionMax: 955,
  checklistScore: 0,
  checklistScoreMax: 0,
  checklistScorePcnt: 0,
  checklistDateCreated: "",
  checklistDateEdited: "",
});

const isShowDummy = computed(() => {
  return (
    (!Object.keys(latestChecklistDetail.value).length || !props.checklistId) &&
    !isLoading.value
  );
});

onMounted(async () => {
  if (props.checklistId) {
    isLoading.value = true;
    await getDataStatusCard();
    await getChecklistDetails();
    isLoading.value = false;
  }
});

watch(
  () => props.checklistId,
  async (value: any) => {
    isLoading.value = true;
    if (value) {
      await getDataStatusCard();
      await getChecklistDetails();
    }
    isLoading.value = false;
  },
);

watch(
  () => props.metric,
  (newValue) => {
    checklistCompletion.value = newValue;
  },
);

const getDataStatusCard = async () => {
  try {
    const res = await getCheckListIdMetricsCompletion(props.checklistId);
    const data = get(res, "data.data", {}) as IChecklistMetricsCompletion;
    checklistMetricsCompletion.value = data;
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const getChecklistDetails = async () => {
  try {
    const res = await getDetailFromCheckListId(Number(props.checklistId));
    const data = get(res, "data.data", {}) as IChecklistInfoDetail;
    checklistLastUpdatedDate.value = data.checklistLastUpdatedDate;
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const checklistMetricsCompletion: Ref<IChecklistMetricsCompletion> = ref(
  {} as IChecklistMetricsCompletion,
);

const percentProgress = computed(() => {
  return parseFloat(
    (checklistMetricsCompletion.value.checklistCompletionPcnt * 100).toFixed(2),
  );
});

const isChecklistMetricsCompletionLoading = computed(() => {
  return Object.keys(checklistMetricsCompletion.value).length === 0;
});

const getLastUpdatedTimeFromNow = () => {
  if (!checklistLastUpdatedDate.value) return "-";
  return getTimeFromNow(checklistLastUpdatedDate.value);
};

const getCurrentTime = () => {
  if (!latestChecklistDetail.value.checklistDateCreated) return "-";
  return convertUTCTimeToLocalTime(
    latestChecklistDetail.value.checklistDateCreated,
    undefined,
    "HH:mm",
  );
};

const goToContinueAssessment = () => {
  const query = { checklistId: checklistMetricsCompletion.value.checklistId };
  router.push({ path: "/assess/input", query });
};
</script>

<style scoped>
.default {
  background: var(--ui-white, #fff);
  color: var(--ui-dark-grey, #878787);
  border-radius: 4px;
  border: 1px solid var(--ui-rule, #eff0f1);
}
</style>
